import {lazy} from 'react'
import * as B from '../block'
import {HeaderBlock} from './HeaderBlock'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

// This imports from component eagerly, because the inner block imports from
// PostHeader and PublicationHeader lazily.

export const headerBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock: HeaderBlock,
})
